import React from 'react';
import { useTheme } from 'ThemeContext';
import { Spacer, Wrapper } from './WidgetSpacerVertical.style';

function WidgetSpacerVertical({ data = {} }) {
  const theme = useTheme();
  return (
    <>
      {data && data.width ? (
        <Wrapper width={data.width}>
          <Spacer color={data.color} theme={theme.widgetSpacerVertical}>
            &nbsp;
          </Spacer>
        </Wrapper>
      ) : (
        ''
      )}
    </>
  );
}

export default WidgetSpacerVertical;
